"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var colors_1 = require("../colors");
var search_1 = tslib_1.__importDefault(require("../icons/search"));
var styled_1 = require("./styled");
var SearchBox = function (_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (react_1.default.createElement(styled_1.Container, { className: className },
        react_1.default.createElement(search_1.default, { size: 18, color: colors_1.gray[2] }),
        react_1.default.createElement("input", tslib_1.__assign({ className: "highlight" }, props))));
};
SearchBox.defaultProps = {
    placeholder: 'Find your favorite menu...',
};
exports.default = SearchBox;
//# sourceMappingURL=index.js.map